import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import SystemMethodTabs from "./components/SystemMethodTabs";
import phone from "./images/phone.png";

import { Image } from "antd";
import localStorageKey from "../../enumerations/localStorageKey";
import styles from "./style.module.scss";
const InstallGuide = () => {
  const systemEnum = {
    IOS: "iOS",
    ANDROID: "android",
  };
  const installMethodEnum = {
    QRCODE: "qrcode",
    MANUAL: "manual",
  };
  const { t } = useTranslation();
  const [nowSystemTab, setNowSystemTab] = useState(systemEnum.IOS);
  const [nowMethod, setNowMethod] = useState(installMethodEnum.QRCODE);
  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);
  const guideImageDict = {
    [systemEnum.IOS]: {
      [installMethodEnum.QRCODE]: {
        src: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/2esim_ios_qr_v2.webp`,
        fallback: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_ios_qr_v2.webp`,
        src2: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/2esim_ios_qr_26.webp`,
        fallback2: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_ios_qr_26.webp`,
      },
      [installMethodEnum.MANUAL]: {
        src: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/2esim_ios_manual.webp`,
        fallback: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_ios_manual.webp`,
      },
    },
    [systemEnum.ANDROID]: {
      [installMethodEnum.QRCODE]: {
        src: `./images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/2esim_android_qr.png`,
        fallback: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_android_qr.png`,
      },
      [installMethodEnum.MANUAL]: {
        src: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/2esim_android_manual.png`,
        fallback: `/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_android_manual.png`,
      },
    },
  };
  useEffect(() => {
    setNowMethod(installMethodEnum.QRCODE);
  }, [nowSystemTab]);

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.leftBox}>
            <h1 className={styles.title}>{t("installguide.title")}</h1>
            <div className={styles.subtitle}>{t("installguide.subtitle")}</div>
            <div className={styles.desc}>{t("installguide.desc")}</div>
          </div>
          <div className={styles.rightBox}>
            <img src={phone} alt="phone" />
          </div>
        </div>
        <SystemMethodTabs
          nowSystemTab={nowSystemTab}
          setNowSystemTab={setNowSystemTab}
          nowMethod={nowMethod}
          setNowMethod={setNowMethod}
          systemEnum={systemEnum}
          installMethodEnum={installMethodEnum}
        />
        <div className={styles.guideContainer}>
          {guideImageDict[nowSystemTab] &&
          guideImageDict[nowSystemTab][nowMethod]?.src2 ? (
            <Image
              src={
                guideImageDict[nowSystemTab]
                  ? guideImageDict[nowSystemTab][nowMethod].src2
                  : ""
              }
              fallback={
                guideImageDict[nowSystemTab]
                  ? guideImageDict[nowSystemTab][nowMethod].fallback2
                  : ""
              }
              alt={t(`alt.guide.${nowSystemTab}.${nowMethod}.26`)}
              preview={false}
            />
          ) : null}
          <Image
            src={
              guideImageDict[nowSystemTab]
                ? guideImageDict[nowSystemTab][nowMethod].src
                : ""
            }
            fallback={
              guideImageDict[nowSystemTab]
                ? guideImageDict[nowSystemTab][nowMethod].fallback
                : ""
            }
            alt={t(`alt.guide.${nowSystemTab}.${nowMethod}`)}
            preview={false}
          />
        </div>
      </div>
    </div>
  );
};

export default InstallGuide;
